import propTypes from 'prop-types';
import React, {Component} from 'react';
import _ from 'lodash';
import SvgIcon from 'material-ui/SvgIcon';
import Subheader from 'material-ui/Subheader';
import MenuItem from 'material-ui/MenuItem';
import * as Colors from 'material-ui/styles/colors';
import DesktopMac from 'material-ui/svg-icons/hardware/desktop-mac';
import {linkVariant} from 'shared/icons/index';
import SplitButton from 'shared/components/SplitButton';
import {UploadImageFromUrlDialog} from 'MyAccount/AssetManager/ImageManager/dialogs';
import {openDialog, closeDialog} from 'MyAccount/AssetManager/ImageManager/helpers';
import {UPLOAD_IMAGE_FROM_URL} from 'MyAccount/AssetManager/ImageManager/consts';
import {isDialogActive} from 'MyAccount/AssetManager/ImageManager/selectors';
import connectWithRouter from 'shared/components/redux/connectWithRouter';
import {
  changeFileStatusSuccess,
  changeFileStatusError,
  pushImageToBar,
  retryUploadFileInBar,
} from 'MyAccount/ViewDesigns/redux/modules/images';

@connectWithRouter(
  (state, ownProps) => ({
    openUploadImageFromUrlDialog: isDialogActive(state, UPLOAD_IMAGE_FROM_URL + ownProps.uniqueIdForUploadDialog),
  }),
  {changeFileStatusSuccess, changeFileStatusError, pushImageToBar, retryUploadFileInBar}
)
export default class UploadImageButton extends Component {
  static contextTypes = {
    imageUtils: propTypes.object.isRequired,
  };

  getSplitButtonItems() {
    return [
      <Subheader key={0} style={{fontSize: '16px'}}>
        Upload images from:
      </Subheader>,
      <MenuItem
        id="cla-menu-item-upload-image-my-computer"
        key={1}
        primaryText="My computer"
        leftIcon={<DesktopMac />}
        onClick={this.inputClick}
      />,
      <MenuItem
        id="cla-menu-item-upload-image-url"
        key={2}
        primaryText="URL"
        leftIcon={
          <SvgIcon color={Colors.grey700}>
            <path d={linkVariant} />
          </SvgIcon>
        }
        onClick={this.openUploadFromUrlDialog}
      />,
    ];
  }

  uploadImages = () => {
    const {uploadImages} = this.props;
    const files = this.file.files;
    uploadImages(files);
    if (this.file) {
      this.file.value = '';
    }
  };

  uploadImagesFromUrl = urls => {
    const {uploadImagesFromUrl} = this.props;
    uploadImagesFromUrl(urls);
  };

  inputClick = () => {
    this.file.click();
  };

  openUploadFromUrlDialog = () => {
    const {openCustomUploadFromUrlDialog, uniqueIdForUploadDialog} = this.props;
    if (_.isFunction(openCustomUploadFromUrlDialog)) {
      openCustomUploadFromUrlDialog();
    } else {
      openDialog({
        dialogName: UPLOAD_IMAGE_FROM_URL + uniqueIdForUploadDialog,
      });
    }
  };

  render() {
    const {disabled, openUploadImageFromUrlDialog, style, buttonLabel, uniqueIdForUploadDialog, id} = this.props;
    return (
      <div style={style}>
        <SplitButton
          id={`${id}-upload-photo`}
          disabled={disabled}
          label={buttonLabel}
          onFirstButtonClick={this.inputClick}
          menuItems={this.getSplitButtonItems()}
          firstButtonStyle={{width: 'auto'}}
        >
          <input
            type="file"
            style={{
              cursor: 'pointer',
              position: 'absolute',
              top: 0,
              bottom: 0,
              right: 0,
              left: 0,
              width: '100%',
              display: 'none',
            }}
            ref={ref => {
              if (ref) {
                this.file = ref;
              }
            }}
            multiple
            onChange={this.uploadImages}
          />
        </SplitButton>
        <UploadImageFromUrlDialog
          key={'UploadImageFromUrl' + uniqueIdForUploadDialog}
          open={openUploadImageFromUrlDialog}
          uploadImagesFromUrl={this.uploadImagesFromUrl}
          closeDialog={closeDialog}
        />
      </div>
    );
  }
}

UploadImageButton.propTypes = {
  openCustomUploadFromUrlDialog: propTypes.func,
  buttonLabel: propTypes.string,
  uniqueIdForUploadDialog: propTypes.string.isRequired,
  uploadImagesFromUrl: propTypes.func.isRequired,
  uploadImages: propTypes.func.isRequired,
};

UploadImageButton.defaultProps = {
  buttonLabel: 'Upload Images',
  uniqueIdForUploadDialog: _.uniqueId(),
};
